export default "__VITE_ASSET__B1svJxAq__"